// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"f3a561be","56":"c96490d9","934":"1b3f70f3"}[chunkId] + ".chunk.css";
};